import React from 'react';
import styled from 'styled-components';

interface LoaderProps {
  className?: string;
}

const Loader = ({ className = '' }: LoaderProps) => (
  <div className={`lds-roller ${className}`} data-testid='component-Loader'>
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);
export default Loader;

// this is created for storybook preview
export const LoaderWrapperForStory = styled.div`
  .lds-roller {
    position: relative;
    height: 300px;
  }
`;
